// Path: ./src/app/pages/CreateUploadFlyer/handleSaveFlyer.ts
import { UpdateGfFlyerDto } from "@swagger/typescript-fetch-goflyer";
import { toastError, toastSuccess } from "../../../utils/pageUtil/toast";
import { messages } from "../../../locales/messages";
import { adminApiService } from "../../../utils/api";
import i18n from "i18next";
import { setValidationStartTimeTo1201AM } from "../../../utils/dateUtil/setTimeTo1201AM";
import { setValidationEndTimeTo1159PM } from "../../../utils/dateUtil/setTimeTo1159PM";
import { useLoading } from "../../../contextApi/LoadingContext";
import { useNavigate } from "react-router-dom";
import { GoFlyerAdminContext } from "../../../contextApi/context";
import { useContext } from "react";
import { useAuthHeaders } from "../../../hooks/useAuthHeaders";

export const useHandleSaveFlyer = () => {
  const { state } = useContext(GoFlyerAdminContext);
  const navigate = useNavigate();
  const { showLoadingScreen } = useLoading();
  const authHeaders = useAuthHeaders();

  const handleSaveFlyer = async (updateUploadFlyer?: UpdateGfFlyerDto) => {
    if (!updateUploadFlyer?.pdf) {
      toastError(`${i18n.t(messages.Name())} ${i18n.t(messages.is_Empty())}`);
      return;
    }
    if (!updateUploadFlyer?.stores && !updateUploadFlyer?.merchant) {
      toastError(
        `${i18n.t(messages.Stores())} ${i18n.t(messages.Merchants())} ${i18n.t(
          messages.is_Empty(),
        )}`,
      );
      return;
    }
    if (!updateUploadFlyer?.flyerTag) {
      toastError(
        `${i18n.t(messages.Flyer_Tag())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }
    if (!updateUploadFlyer?.validStartDate) {
      toastError(
        `${i18n.t(messages.validStartDate())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }
    if (!updateUploadFlyer?.validEndDate) {
      toastError(
        `${i18n.t(messages.validEndDate())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }
    if (
      !updateUploadFlyer?.gfImages ||
      updateUploadFlyer?.gfImages.length === 0
    ) {
      toastError(
        `${i18n.t(messages.gfImages())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }

    if (!state.gfAdminUser) {
      toastError(
        `${i18n.t(messages.There_is_an_error_please_Contact_Administrator())}`,
      );
      return;
    }

    showLoadingScreen(true);
    let savedFlyer;
    try {
      savedFlyer = updateUploadFlyer.id
        ? await adminApiService.updateOneBaseGfFlyerAdminControllerGfFlyer(
            {
              ...updateUploadFlyer,
              validStartDate: setValidationStartTimeTo1201AM(
                updateUploadFlyer.validStartDate,
              ),
              validEndDate: setValidationEndTimeTo1159PM(
                updateUploadFlyer.validEndDate,
              ),
            },
            updateUploadFlyer.id,
            authHeaders,
          )
        : await adminApiService.createOneBaseGfFlyerAdminControllerGfFlyer({
            ...updateUploadFlyer, //This is for optional properties
            pdf: updateUploadFlyer.pdf,
            stores: updateUploadFlyer.stores,
            merchant: updateUploadFlyer.merchant,
            flyerTag: updateUploadFlyer.flyerTag,
            validStartDate: setValidationStartTimeTo1201AM(
              updateUploadFlyer.validStartDate,
            ),
            validEndDate: setValidationEndTimeTo1159PM(
              updateUploadFlyer.validEndDate,
            ),
            gfImages: updateUploadFlyer.gfImages,
            rank: updateUploadFlyer.rank,
            adminUser: state.gfAdminUser,
          });
    } finally {
      showLoadingScreen(false);
    }

    if (!savedFlyer) {
      return;
    }

    toastSuccess(i18n.t(messages.Flyer_Uploaded_Successfully()));
    navigate(-1);
    return savedFlyer;
  };
  return handleSaveFlyer;
};
